const MINOR_AGE_THRESHOLD = 18;

export function calculateAge(dateOfBirth: string): number {
  const dob = new Date(`${dateOfBirth}T00:00:00.000Z`);
  const today = new Date();
  let age = today.getUTCFullYear() - dob.getUTCFullYear();
  const monthDelta = today.getUTCMonth() - dob.getUTCMonth();
  if (monthDelta < 0 || (monthDelta === 0 && today.getUTCDate() < dob.getUTCDate())) {
    age -= 1;
  }
  return age;
}

export function isMinor(dateOfBirth: string): boolean {
  if (!dateOfBirth) {
    return false;
  }
  return calculateAge(dateOfBirth) < MINOR_AGE_THRESHOLD;
}
